export enum CUSTOM_PROXY_TYPE {
  PROXY_REF = 'proxyRef',
  SIMULATION = 'simulation',
}
